import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { EmbalagensResponse } from 'src/app/models/EmbalagensResponse';
import { TripPayload } from 'src/app/models/PackingPlanningModel';
import { TrucksResponse } from 'src/app/models/TrucksModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmbalagemService {

  apiLink = environment.apiLink;
  httpOption = httpOptions

  constructor(private http: HttpClient) { }

  getEmbDocksData(): Observable<EmbalagensResponse> {
    return this.http.get<EmbalagensResponse>(`${this.apiLink}/Emb/Docks`, httpOptions)
  }

  getEmbDocksDataView(): Observable<EmbalagensResponse> {
    return this.http.get<EmbalagensResponse>(`${this.apiLink}/View/Emb/Docks`, httpOptions)
  }

  getEmbTrips(): Observable<TrucksResponse> {
    return this.http.get<any>(`${this.apiLink}/Emb/Trucks`, httpOptions)
  }

  getEmbTripsView(): Observable<TrucksResponse> {
    return this.http.get<any>(`${this.apiLink}/View/Emb/Trucks`, httpOptions)
  }

  updateTrucksTable(payload: Omit<TripPayload, 'diferencial'>, dockId: number, tripClassification: string): Observable<any> {
    const options = {
      ...httpOptions,
      params: new HttpParams()
        .set('dockId', dockId)
        .set('tripClassification', tripClassification)
    }
    return this.http.put(`${this.apiLink}/Emb/Trucks`, payload, options)
  }
}
